import { UserManagementGrid } from "@/components/admin/UserManagementGrid";
import { usePageBreadcrumbs } from "@/components/layout/breadcrumb-context";
import { useMemo } from "react";
import { Users } from "lucide-react";

export default function AdminUsersPage() {
  const breadcrumbs = useMemo(
    () => [
      { label: "Recipe Boxes", href: "/home" },
      { label: "Admin", href: "/admin" },
      { label: "Users" },
    ],
    [],
  );
  usePageBreadcrumbs(breadcrumbs);

  return (
    <div className="container max-w-7xl mx-auto py-6 px-4 space-y-6">
      {/* Header */}
      <div className="space-y-2">
        <div className="flex items-center gap-3">
          <Users className="h-8 w-8 text-primary" />
          <h1 className="font-headline text-3xl font-semibold tracking-tight">User Management</h1>
        </div>
        <p className="text-muted-foreground">Manage user profiles, account tiers, and permissions.</p>
      </div>

      {/* User Management Grid */}
      <UserManagementGrid />
    </div>
  );
}

